import { useSetRecoilState } from "recoil";
import { phrasesAPIErrorAtom } from "./phrasesAPIErrorAtom";

export function useSetPhrasesAPIErrorState() {
    return useSetRecoilState(phrasesAPIErrorAtom);
}
